<template>
  <h3>
    <slot />
  </h3>
</template>

<style lang="scss" scoped>
h3 {
  @include title-is-4;
  color: $shades_grey-dark;
  text-align: center;
  font-family: $family-lexend;
}
</style>
